import { render, staticRenderFns } from "./contactbox.vue?vue&type=template&id=3b25be50&scoped=true"
import script from "./contactbox.vue?vue&type=script&lang=js"
export * from "./contactbox.vue?vue&type=script&lang=js"
import style0 from "./contactbox.vue?vue&type=style&index=0&id=3b25be50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b25be50",
  null
  
)

export default component.exports